import React from "react";
import { Row, Col, Button, Form, Tabs, Tab } from "@themesberg/react-bootstrap";
import { SpinnerLoader } from "../../../../../components/Preloader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedo } from "@fortawesome/free-solid-svg-icons";
import PaginationComponent from "../../../../../components/Pagination";
import useUserStats from "../../hooks/useUserStats";
import UserStatsTable from "../../../../../components/UserStatsTable";
import DateRangePicker from "../../../../../components/DateRangePicker";
import { downloadFile } from "../../../../../utils/fileDownloader";

export default () => {
  const {
    loadUserStats,
    loading,
    setState,
    state,
    filter,
    setSelectedFilter,
    limit,
    setLimit,
    page,
    setPage,
    totalPages,
    filters,
    UserStats,
    getCsvDownloadUrl,
    search,
    setSearch,
    handleResetFilters,
    handleDownload
  } = useUserStats();

  const isCustom = filter === "custom"
  return (
    <>
      <Row className="align-items-center mb-3 flex-md-row flex-column">
        {/* Title Column - occupies less space on md+ */}
        <Col xs={12} xl={3} className="mb-2 mb-md-0">
          <h3 className="d-flex mb-0">
            User Stats{" "}
            {loading ? (
              <SpinnerLoader />
            ) : (
              <FontAwesomeIcon
                onClick={handleResetFilters}
                style={{
                  fontSize: "15px",
                  color: "gray",
                  cursor: "pointer",
                  marginTop: "5px",
                  marginLeft: "10px",
                }}
                icon={faRedo}
              />
            )}
          </h3>

          <Form.Control
              type="search"
              placeholder="Search Email, Name, Username"
              size="sm"
              value={search}
              onChange={(event) => setSearch(event.target.value)}
              className={filter === "custom" ? "me-md-2 mt-2 mb-2 d-md-block d-lg-none" : "d-none"  }
              // className="me-md-2 mt-2 mb-2 d-md-block d-lg-none"
            />

{filter === "custom" && (
              <div               className={filter === "custom" ? "me-md-2 mt-2 mb-2 d-md-block d-lg-none" : "d-none"  }
>
                <DateRangePicker state={state} setState={setState} size="sm" isMAXwidth={true}/>
              </div>
            )}

        </Col>

        {/* Filters + Export Column */}
        <Col xs={12} xl={9}>
          <div className="d-flex flex-column flex-md-row justify-content-md-end align-items-md-center gap-2">
            {/* Search Input */}
            <Form.Control
              type="search"
              placeholder="Search Email, Name, Username"
              size="sm"
              // style={{ maxWidth: "230px", maxHeight: "15px" }}
              value={search}
              onChange={(event) => setSearch(event.target.value)}
              className={filter == "custom" ? "me-md-2 d-none d-lg-block" : "me-md-2"  }
              
            />

            {/* Custom Date Range Picker */}
            {filter === "custom" && (
              <div               className={filter == "custom" ? "me-md-2 d-none d-lg-block" : "me-md-2"  }
>
                <DateRangePicker state={state} setState={setState} size="sm" />
              </div>
            )}

            {/* Filter Dropdown */}
            <div className="d-flex flex-column flex-md-row align-items-md-center">
              <Form.Label className="mb-1 mb-md-0 me-md-2">Filter</Form.Label>
              <Form.Select
                onChange={(e) => setSelectedFilter(e.target.value)}
                value={filter}
                size="sm"
                style={{ width: "auto" }}
              >
                {filters[0].map(({ label, key }) => (
                  <option value={key} key={key}>
                    {label}
                  </option>
                ))}
              </Form.Select>
            </div>

            {/* Export Button */}
            <Button
              variant="outline-success"
              size="sm"
              style={{ width: "150px" }}
              disabled={UserStats?.data?.length < 1}
              onClick={() => handleDownload(getCsvDownloadUrl("csv", "user-stats"))}
            >
              Export Details
            </Button>
          </div>
        </Col>
      </Row>


      <UserStatsTable
        UserInfo={UserStats?.data}
        UserStats={UserStats?.stats}
      />
      {UserStats?.count !== 0 && !loading && (
        <PaginationComponent
          page={UserStats?.pagination?.count < page ? setPage(1) : page}
          totalPages={totalPages}
          setPage={setPage}
          limit={limit}
          dontShowRow={false}
          setLimit={setLimit}
        />
      )}
    </>
  );
};
